'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { callIfPossible } from '../../core/Functions';
import SyntheticEvent from '../../core/SyntheticEvent';
import { isLeftClick } from '../../utils/DomEvents';

class UIAbstractSlider extends PureComponent {
  constructor(props) {
    super(props);

    this.handleMouseDown = evt => {
      const {
        onMouseDown,
        onDragStart
      } = this.props;
      callIfPossible(onMouseDown, evt);
      if (evt.defaultPrevented) return;

      if (isLeftClick(evt)) {
        this.updatePosition(evt.clientX);
        callIfPossible(onDragStart);
        this.bindWindowListeners();
      }
    };

    this.handleWindowMouseMove = evt => {
      this.updatePosition(evt.clientX);
    };

    this.handleWindowMouseUp = () => {
      const {
        onDragEnd
      } = this.props;
      callIfPossible(onDragEnd);
      this.unbindWindowListeners();
    };

    this.refCallback = ref => {
      this._el = ref;
    };

    this.state = {
      Dragging: false
    };
  }

  componentWillUnmount() {
    this.unbindWindowListeners();
  }

  bindWindowListeners() {
    addEventListener('mousemove', this.handleWindowMouseMove);
    addEventListener('mouseup', this.handleWindowMouseUp);
  }

  unbindWindowListeners() {
    removeEventListener('mousemove', this.handleWindowMouseMove);
    removeEventListener('mouseup', this.handleWindowMouseUp);
  }

  updatePosition(clientX) {
    const {
      onDrag
    } = this.props;
    if (this._el == null) return;

    const {
      left,
      right
    } = this._el.getBoundingClientRect();

    if (left === right) return;
    let DragPercentX = (clientX - left) / (right - left);
    if (DragPercentX < 0) DragPercentX = 0;
    if (DragPercentX > 1) DragPercentX = 1;
    callIfPossible(onDrag, SyntheticEvent({
      percentX: DragPercentX
    }));
  }

  render() {
    const _this$props = this.props,
          {
      children
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "onMouseDown", "onDragStart", "onDragEnd", "onDrag"]);

    return (
      /*#__PURE__*/

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _jsx("div", Object.assign({}, rest, {
        onMouseDown: this.handleMouseDown,
        ref: this.refCallback,
        children: children
      }))
      /* eslint-enable jsx-a11y/no-static-element-interactions */

    );
  }

}

UIAbstractSlider.propTypes = {
  'aria-label': PropTypes.string,
  'aria-valuemax': PropTypes.number,
  'aria-valuemin': PropTypes.number,
  'aria-valuenow': PropTypes.number,
  'aria-valuetext': PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  'data-test-id': PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  onDrag: PropTypes.func,
  onDragEnd: PropTypes.func,
  onDragStart: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseDown: PropTypes.func,
  role: PropTypes.string,
  style: PropTypes.object,
  tabIndex: PropTypes.number
};
UIAbstractSlider.displayName = 'UIAbstractSlider';
export default UIAbstractSlider;